import { createStatefullProvider } from "../../../base/helpers/createContext";

export const TableContext = createStatefullProvider({});
